const getters = {
  getQuotation: (state) => state.quotation,
  getQuotationList: (state) => state.quotationList,
  getQuotationListMeta: (state) => state.quotationListMeta,
};

export default getters;
